import { useEffect, useRef } from 'react';

/**
 * Hook to fix desktop scroll issues
 * Ensures wheel events work correctly even when hovering over interactive elements
 */
export function useScrollFix() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Find the main scroll container - look for overflow-y-auto inside main
    const container = document.querySelector('main div.overflow-y-auto') as HTMLElement;
    
    if (!container) {
      return;
    }

    const handleWheel = (e: WheelEvent) => {
      const target = e.target as HTMLElement;

      // Check if target is inside a nested scrollable container
      // If so, let native scroll handle it instead of intercepting
      let el = target.parentElement;
      while (el && el !== container) {
        const overflowY = window.getComputedStyle(el).overflowY;
        if (overflowY === 'auto' || overflowY === 'scroll') {
          return;
        }
        el = el.parentElement;
      }

      // Check if we're inside a card or interactive element
      const isInteractiveElement = 
        target.closest('a') || 
        target.closest('button') || 
        target.closest('[class*="block rounded"]') ||
        target.closest('[class*="card"]');

      if (!isInteractiveElement) return;

      // Prevent default and manually scroll the outer container
      e.preventDefault?.();
      container.scrollTop += e.deltaY;
    };

    // Use passive: false to allow preventDefault
    container.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      container.removeEventListener('wheel', handleWheel);
    };
  }, []);

  return scrollContainerRef;
}

export default useScrollFix;
